import { Helmet } from 'react-helmet-async'
import AppGatewayCalc from '../components/calculators/AppGatewayCalc'
import { Breadcrumbs } from '../components/shared/Breadcrumbs'
import { generateBreadcrumbList } from '../utils/schemaHelpers'

export default function ApplicationGatewayPage() {
  return (
    <>
      <Helmet>
        <title>Azure Application Gateway + WAF Cost Calculator UK | AzureCalc.uk</title>
        <meta name="description" content="Estimate Azure Application Gateway v2 and WAF v2 costs in GBP for UK South. Model autoscale capacity units, peak vs average traffic, data processing fees, and compare Standard v2 vs WAF v2." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/application-gateway" />
        <meta property="og:title" content="Azure Application Gateway + WAF Cost Calculator UK" />
        <meta property="og:description" content="Application Gateway v2 and WAF v2 pricing in GBP for UK South — model autoscale CUs, peak traffic scenarios, and the 10 TB free data tier." />
        <meta property="og:url" content="https://www.azure-calc.co.uk/application-gateway" />
        <meta property="og:image" content="https://www.azure-calc.co.uk/og/azure-calc-og.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify(generateBreadcrumbList([
          { name: 'Home', url: '/', position: 1 },
          { name: 'Application Gateway Calculator', url: '/application-gateway', position: 2 },
        ]))}</script>
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebApplication',
          name: 'Azure Application Gateway + WAF Cost Calculator',
          description: 'Independent Application Gateway v2 pricing calculator for UK South — model autoscale capacity units, peak traffic, WAF v2, and data processing costs in GBP.',
          url: 'https://www.azure-calc.co.uk/application-gateway',
          applicationCategory: 'FinanceApplication',
          operatingSystem: 'Web',
          offers: { '@type': 'Offer', price: '0', priceCurrency: 'GBP' },
        })}</script>
      </Helmet>

      <div className="px-6 py-6 w-full">
        <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
          <Breadcrumbs />
          <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
            Azure Application Gateway + WAF Cost Calculator
          </h1>
          <p className="text-sm" style={{ color: 'var(--text-tertiary)' }}>
            UK South pricing · Standard v2 / WAF v2 · Autoscale CUs · Peak vs average scenarios
          </p>
        </div>

        <AppGatewayCalc />
      </div>
    </>
  )
}
